<template>
  <div class="py-3">
    <page-title title="Subscriptions" />
    <hr />
    <filtered-table :settings="tableSettings" @rowClicked="onRowClicked">
    </filtered-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SubscriptionList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        endpoint: '/api/subscription',
        columns: [
          {
            key: 'id',
            name: 'ID',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'displayName',
            name: 'Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'stripeExpiration',
            name: 'Expiration',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'stripeStatus',
            name: 'Status',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'stripePromotionCodeId',
            name: 'Promotion Code',
            visible: true,
            sortable: true,
            filter: 'text'
          }
        ],
        getDefaultFilter: function () {
          return '';
        }
      }
    }
  },
  methods: {
    onRowClicked: function (item, context) {
      this.$router.push('/subscription/' + item.id);
    }
  },
  mounted () {
  }
};
</script>